import type {
  ProductBenefitSectionRecordModelType,
  RangeDescriptionSectionRecordModelType,
} from '@/models/api';

import { ProductBenefitSection } from '../ProductBenefitSection/ProductBenefitSection';
import { RangeDescription } from '../RangeDescription/RangeDescription';

export type SectionsContainerType = {
  sections?: (
    | ProductBenefitSectionRecordModelType
    | RangeDescriptionSectionRecordModelType
  )[];
  showButton?: boolean;
};

export const SectionsContainer: React.FC<SectionsContainerType> = ({
  sections,
  showButton,
}) => {
  if (!sections || sections.length === 0) return null;

  const renderSection = (
    section:
      | ProductBenefitSectionRecordModelType
      | RangeDescriptionSectionRecordModelType,
    index: number,
  ) => {
    switch (section.__typename) {
      case 'RangeDescriptionSectionRecord':
        return (
          <RangeDescription
            section={section}
            key={index}
            showButton={showButton}
          />
        );
      case 'ProductBenefitSectionRecord':
        return <ProductBenefitSection section={section} key={index} />;
      default:
        return null;
    }
  };

  return (
    <div className="p-4 md:pl-4 lg:pl-16">
      {sections &&
        sections.length > 0 &&
        sections.map((section: any, index) => renderSection(section, index))}
    </div>
  );
};
